import React from "react";
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryLabel,
  Style,
} from "victory";

const Dashboard = ({ type, ListType, monthList, dayList, weekList }) => {
  const getColor = (value) => {
    if (value <= 20) {
      return "#bbceff";
    } else if (value <= 40) {
      return "#7ca1ff";
    } else if (value <= 70) {
      return "#517ae0";
    } else {
      return "#3367EF";
    }
  };

  const getData = () => {
    switch (ListType) {
      case "Day":
        return dayList;
      case "Week":
        return weekList;
      case "Month":
        return monthList;
    }
  };

  const getData2 = () => {
    switch (ListType) {
      case "Hour":
        return monthList;
      case "Day":
        return dayList;
    }
  };

  const List = type === "0" ? getData() : type === "1" ? getData2() : monthList;

  console.log("INSIDE DASHBOARD");
  console.log(List);
  console.log(ListType);
  console.log(type);
  console.log("OUTSIDE DASHBOARD");

  return (
    <VictoryChart domainPadding={{ x: 130 }} height={250} width={1000}>
      <VictoryAxis
        style={{
          tickLabels: {
            fill: "gray",
            fontWeight: "bold",
            fontSize: "20px",
          },
        }}
        tickFormat={(x) => `${x}`}
      />
      <VictoryAxis dependentAxis />
      <VictoryBar
        data={List}
        x="x"
        y="y"
        style={{
          data: { fill: "#3367EF", fill: ({ datum }) => getColor(datum.y) },
        }}
        cornerRadius={{ top: 25 }}
        barWidth={62}
        labels={({ datum }) => datum.y}
        labelComponent={
          <VictoryLabel
            dy={-10}
            style={{ fill: "gray", fontWeight: "bold", fontSize: "20px" }}
          />
        }
      />
    </VictoryChart>
  );
};

export default Dashboard;
